import { requestApi } from 'api/api'
import {
  CreatePortfolioRequest,
  CustomerEarningsSummaryParams,
  CustomerEarningsSummaryResponse,
  EarningsDistributionResponse,
  GetMonthlyCustomersEarningsParams,
  GetMonthlyCustomersEarningsResponse,
  GetPortfoliosParams,
  GetPortfoliosResponse,
  GetRewardsProductsParams,
  GetRewardsProductsResponse,
  Portfolio,
  PortfolioTransportRequest,
  PortfolioTransportResponse,
  UpdateEarningsDistributionRequest,
} from 'types/rewards'

export const createPortfolio = async (data: CreatePortfolioRequest): Promise<Portfolio> => {
  return requestApi({
    url: '/earn/v1/portfolios',
    baseUrl: process.env.API_URL,
    method: 'POST',
    data,
  })
}

export const getPortfolios = async ({
  pageNumber,
  pageSize,
}: GetPortfoliosParams): Promise<GetPortfoliosResponse> => {
  return requestApi({
    url: '/earn/v1/portfolios',
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      ...(pageNumber && { pageNumber }),
      ...(pageSize && { pageSize }),
    },
  })
}

export const getPortfolio = async (portfolioId: string): Promise<Portfolio> => {
  return requestApi({
    url: `/earn/v1/portfolios/${portfolioId}`,
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}

export const depositToPortfolio = async (
  data: PortfolioTransportRequest
): Promise<PortfolioTransportResponse> => {
  return requestApi({
    url: '/earn/v1/deposits',
    baseUrl: process.env.API_URL,
    method: 'POST',
    data,
  })
}

export const withdrawFromPortfolio = async (
  data: PortfolioTransportRequest
): Promise<PortfolioTransportResponse> => {
  return requestApi({
    url: '/earn/v1/withdrawals',
    baseUrl: process.env.API_URL,
    method: 'POST',
    data,
  })
}

export const getRewardsProducts = async ({
  pageSize,
  pageNumber,
  currency,
}: GetRewardsProductsParams): Promise<GetRewardsProductsResponse> => {
  return requestApi({
    url: '/earn/v1/earning-products',
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      ...(pageSize && { pageSize }),
      ...(pageNumber && { pageNumber }),
      ...(currency && { currency }),
    },
  })
}

export const getRewardsProduct = async (
  rewardsProductId: string
): Promise<GetRewardsProductsResponse> => {
  return requestApi({
    url: `/earn/v1/earning-products/${rewardsProductId}`,
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}

export const getCustomerEarningsSummary = async ({
  currency,
}: CustomerEarningsSummaryParams): Promise<CustomerEarningsSummaryResponse> => {
  return requestApi({
    url: '/earn/v1/customers-earnings-summary',
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      currency,
    },
  })
}

export const getMonthlyCustomersEarnings = async ({
  currency,
  startDate,
  endDate,
  pageNumber,
  pageSize,
}: GetMonthlyCustomersEarningsParams): Promise<GetMonthlyCustomersEarningsResponse> => {
  return requestApi({
    url: '/earn/v1/monthly-customers-earnings',
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      currency,
      ...(startDate && { startDate }),
      ...(endDate && { endDate }),
      ...(pageNumber !== undefined && { pageNumber }),
      ...(pageSize && { pageSize }),
    },
  })
}

export const updateEarningsDistribution = async (
  data: UpdateEarningsDistributionRequest
): Promise<EarningsDistributionResponse> => {
  return requestApi({
    url: '/earn/v1/earnings-distributions',
    baseUrl: process.env.API_URL,
    method: 'POST',
    data,
  })
}
